$(function(){
    var datePicker = $('.datepicker');
	datePicker.each(function(){
		$(this).flatpickr({
		    dateFormat: "d-m-Y",
		});
	});
})